import React from 'react';
import { User } from '../../types';
import Logo from './Logo';

interface HeaderProps {
  user: User | null;
  onLogout: () => void;
  onOpenAccessibilityModal: () => void;
  setView: (view: 'landing' | 'dashboard' | 'guest' | 'join') => void;
  openAuthModal: (view: 'login' | 'register') => void;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout, onOpenAccessibilityModal, setView, openAuthModal }) => {
  const LoggedOutMenu = () => (
    <div>
        <div className="flex items-center space-x-2">
            <button onClick={() => setView('guest')} className="hidden sm:inline px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600">Features</button>
            <button onClick={() => setView('join')} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">Join With Code</button>
            <button onClick={() => openAuthModal('login')} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600">Login</button>
            <button onClick={() => openAuthModal('register')} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">Sign Up</button>
        </div>
    </div>
  );

  const LoggedInMenu = () => (
     <div className="flex items-center space-x-2">
        <span className="text-gray-600 mr-4 hidden sm:inline">Welcome, {user?.email}</span>
        <button
          onClick={onOpenAccessibilityModal}
          title="Accessibility Settings"
          className="p-2 rounded-full hover:bg-gray-100 text-gray-600"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        </button>
        <button
          onClick={onLogout}
          title="Logout"
          className="p-2 rounded-full hover:bg-gray-100 text-gray-600"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
        </button>
      </div>
  );

  return (
    <header className="w-full bg-white shadow-md p-4 flex justify-between items-center sticky top-0 z-40">
      <button onClick={() => setView(user ? 'dashboard' : 'landing')} className="hover:opacity-80 transition-opacity">
        <Logo />
      </button>
      <div className="flex items-center space-x-4">
        {user ? <LoggedInMenu /> : <LoggedOutMenu />}
      </div>
    </header>
  );
};

export default Header;